import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, X, Video } from "lucide-react";

const GalleryPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const categories = [
    "all",
    "temple",
    "construction",
    "festivals",
    "ceremonies",
    "Brochure",
  ];

  const galleryItems = [
    // ========= TEMPLE CATEGORY =========
    { id: 1, category: "temple", image: "/images/img1.jpg" },
    { id: 2, category: "temple", image: "/images/img2.jpg" },
    { id: 3, category: "temple", image: "/images/img3.jpg" },
    { id: 4, category: "temple", image: "/images/img4.jpg" },
    { id: 5, category: "temple", image: "/images/img5.jpg" },
    { id: 6, category: "temple", image: "/images/img6.jpg" },
    { id: 7, category: "temple", image: "/images/img7.jpg" },
    { id: 8, category: "temple", image: "/images/img8.jpg" },
    { id: 9, category: "temple", image: "/images/img9.jpg" },
    { id: 10, category: "temple", image: "/images/img21.jpeg" },
    { id: 11, category: "temple", image: "/images/img35.jpeg" },
    { id: 12, category: "temple", image: "/images/img36.jpeg" },
    { id: 13, category: "temple", image: "/images/img37.jpeg" },
    { id: 14, category: "temple", image: "/images/img38.jpeg" },
    { id: 15, category: "temple", image: "/images/img39.jpeg" },
    { id: 16, category: "temple", image: "/images/img40.jpeg" },
    { id: 17, category: "temple", image: "/images/img41.jpeg" },
    { id: 18, category: "temple", image: "/images/img42.jpeg" },
    { id: 19, category: "temple", image: "/images/img43.jpeg" },
    { id: 20, category: "temple", image: "/images/img44.jpeg" },
    { id: 21, category: "temple", image: "/images/img52.jpeg" },

    // ========= TEMPLE CONSTRUCTION CATEGORY =========
    { id: 101, category: "construction", image: "/images/img23.jpeg" },
    { id: 102, category: "construction", image: "/images/img24.jpeg" },
    { id: 103, category: "construction", image: "/images/img25.jpeg" },
    { id: 104, category: "construction", image: "/images/img26.jpeg" },
    { id: 105, category: "construction", image: "/images/img27.jpeg" },
    { id: 106, category: "construction", image: "/images/img28.jpeg" },
    { id: 107, category: "construction", image: "/images/img29.jpeg" },
    { id: 308, category: "construction", image: "/images/video01.mp4" },
    { id: 309, category: "construction", image: "/images/video02.mp4" },

    // ========= FESTIVALS CATEGORY =========
    { id: 201, category: "festivals", image: "/images/img13.jpeg" },
    { id: 202, category: "festivals", image: "/images/img14.jpeg" },
    { id: 203, category: "festivals", image: "/images/img16.jpeg" },
    { id: 204, category: "festivals", image: "/images/img18.jpeg" },
    { id: 205, category: "festivals", image: "/images/img20.jpeg" },
    { id: 310, category: "festivals", image: "/images/video03.mp4" },
    { id: 311, category: "festivals", image: "/images/img30.jpeg" },
    { id: 312, category: "festivals", image: "/images/img31.jpeg" },
    { id: 313, category: "festivals", image: "/images/img32.jpeg" },
    { id: 314, category: "festivals", image: "/images/img33.jpeg" },
    { id: 315, category: "festivals", image: "/images/img34.jpeg" },
    { id: 316, category: "festivals", image: "/images/img45.jpeg" },
    { id: 317, category: "festivals", image: "/images/img46.jpeg" },
    { id: 318, category: "festivals", image: "/images/img47.jpeg" },
    { id: 319, category: "festivals", image: "/images/img48.jpeg" },
    { id: 320, category: "festivals", image: "/images/img49.jpeg" },
    { id: 321, category: "festivals", image: "/images/img50.jpeg" },
    { id: 322, category: "festivals", image: "/images/img51.jpeg" },
    { id: 323, category: "festivals", image: "/images/img53.jpeg" },
    { id: 324, category: "festivals", image: "/images/img54.jpeg" },
    { id: 325, category: "festivals", image: "/images/img55.jpeg" },
    { id: 326, category: "festivals", image: "/images/img56.jpeg" },
    { id: 327, category: "festivals", image: "/images/img57.jpeg" },
    { id: 328, category: "festivals", image: "/images/img58.jpeg" },
    { id: 329, category: "festivals", image: "/images/img59.jpeg" },
    { id: 330, category: "festivals", image: "/images/img60.jpeg" },
    { id: 331, category: "festivals", image: "/images/img61.jpeg" },
    { id: 332, category: "festivals", image: "/images/img62.jpeg" },
    { id: 333, category: "festivals", image: "/images/img63.jpeg" },
    { id: 334, category: "festivals", image: "/images/img64.jpeg" },
    { id: 335, category: "festivals", image: "/images/video04.mp4" },
    { id: 336, category: "festivals", image: "/images/video05.mp4" },
    { id: 337, category: "festivals", image: "/images/video06.mp4" },
    { id: 338, category: "festivals", image: "/images/video07.mp4" },
    { id: 339, category: "festivals", image: "/images/video08.mp4" },

    // ========= CEREMONIES CATEGORY =========
    { id: 301, category: "ceremonies", image: "/images/img10.jpeg" },
    { id: 302, category: "ceremonies", image: "/images/img11.jpeg" },
    { id: 303, category: "ceremonies", image: "/images/img12.jpeg" },
    { id: 304, category: "ceremonies", image: "/images/img15.jpeg" },
    { id: 305, category: "ceremonies", image: "/images/img17.jpeg" },
    { id: 306, category: "ceremonies", image: "/images/img19.jpeg" },
    { id: 307, category: "ceremonies", image: "/images/img22.jpeg" },

    // ========= BROCHURE CATEGORY =========
    {
      id: 401,
      category: "Brochure",
      file: "/images/SriKalikamundeshwari01pdf.pdf",
      image: "/images/skkd01.jpg",
      title: "Temple Brochure",
    },
    {
      id: 402,
      category: "Brochure",
      file: "/images/SriKalikamundeshwari02pdf.pdf",
      image: "/images/skkd02.png",
      title: "New temple brochure",
    },
    {
      id: 403,
      category: "Brochure",
      file: "/images/SriKalikamundeshwari03pdf.pdf",
      image: "/images/skkd03.png",
      title: "New temple brochure",
    },
  ];

  const filteredItems =
    selectedCategory === "all"
      ? galleryItems
      : galleryItems.filter((item) => item.category === selectedCategory);

  const nextImage = () => {
    setSelectedImageIndex((prev) =>
      prev === filteredItems.length - 1 ? 0 : prev + 1,
    );
  };

  const prevImage = () => {
    setSelectedImageIndex((prev) =>
      prev === 0 ? filteredItems.length - 1 : prev - 1,
    );
  };

  const handleKeyPress = (e) => {
    if (selectedImageIndex !== null) {
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "Escape") setSelectedImageIndex(null);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [selectedImageIndex]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-yellow-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <h1 className="text-4xl font-bold text-center mb-4 text-gray-800">
          Temple Gallery
        </h1>
        <p className="text-center text-gray-600 mb-8">
          Explore {galleryItems.length} photos categorized by type
        </p>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center mb-12 gap-3">
          {categories.map((category) => {
            const count =
              category === "all"
                ? galleryItems.length
                : galleryItems.filter((item) => item.category === category)
                    .length;

            return (
              <button
                key={category}
                onClick={() => {
                  setSelectedCategory(category);
                  setSelectedImageIndex(null); // reset opened image when switching tab
                }}
                className={`px-6 py-3 rounded-full capitalize transition-all duration-500 transform font-medium ${
                  selectedCategory === category
                    ? "bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-2xl scale-105"
                    : "bg-white/80 backdrop-blur-sm text-gray-700 hover:bg-orange-100 hover:scale-105 shadow-lg"
                }`}
              >
                <span className="flex items-center gap-2">
                  {category === "construction" ? "Construction" : category}
                  <span
                    className={`text-sm font-bold px-2 py-1 rounded-full ${
                      selectedCategory === category
                        ? "bg-white/30"
                        : "bg-gray-200"
                    }`}
                  >
                    {count}
                  </span>
                </span>
              </button>
            );
          })}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredItems.map((item, index) => (
            <div
              key={item.id}
              className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
              style={{
                animationDelay: `${index * 100}ms`,
                animation: "slideInUp 0.8s ease-out forwards",
              }}
              onClick={() => {
                if (item.file) {
                  window.open(item.file, "_blank");
                } else {
                  setSelectedImageIndex(index);
                }
              }}
            >
              <div className="relative aspect-square overflow-hidden">
                {item.image?.endsWith(".mp4") ? (
                  <>
                    <video
                      src={item.image}
                      className="w-full h-full object-cover"
                      muted
                      loop
                      autoPlay
                      playsInline
                      preload="metadata"
                    />
                    <div className="absolute top-3 right-3 z-20 rounded-full bg-black/70 p-2 text-white">
                      <Video className="w-4 h-4" />
                    </div>
                  </>
                ) : (
                  <img
                    src={item.image}
                    alt={item.title || "Gallery item"}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                )}
                <div className="w-full h-full bg-gradient-to-br from-orange-200 to-yellow-200 flex items-center justify-center text-6xl hidden">
                  🏛️
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Image Modal */}
        {selectedImageIndex !== null && (
          <div className="fixed inset-0 bg-black/90 flex items-start justify-center z-50 animate-fadeIn backdrop-blur-sm pt-8">
            {/* Close Button */}
            <button
              onClick={() => setSelectedImageIndex(null)}
              className="absolute top-4 right-4 z-10 bg-black/50 backdrop-blur-sm rounded-full p-3 text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 border border-white/20"
            >
              <X size={28} />
            </button>

            {/* Previous Arrow */}
            <button
              onClick={prevImage}
              className="absolute left-4 top-1/3 transform -translate-y-1/2 z-10 bg-black/50 backdrop-blur-sm rounded-full p-3 text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 border border-white/20"
            >
              <ChevronLeft size={40} />
            </button>

            {/* Next Arrow */}
            <button
              onClick={nextImage}
              className="absolute right-4 top-1/3 transform -translate-y-1/2 z-10 bg-black/50 backdrop-blur-sm rounded-full p-3 text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 border border-white/20"
            >
              <ChevronRight size={40} />
            </button>

            {/* Main Image */}
            <div className="relative max-w-xl max-h-[50vh] mx-8 animate-scaleIn">
              {filteredItems[selectedImageIndex]?.image?.endsWith(".mp4") ? (
                <video
                  src={filteredItems[selectedImageIndex]?.image}
                  controls
                  autoPlay
                  playsInline
                  className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
                />
              ) : (
                <img
                  src={filteredItems[selectedImageIndex]?.image}
                  alt={`Gallery image ${selectedImageIndex + 1}`}
                  className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
              )}
              <div className="w-80 h-80 bg-gradient-to-br from-orange-200 to-yellow-200 flex items-center justify-center text-8xl rounded-lg shadow-2xl hidden">
                🏛️
              </div>
            </div>

            {/* Image Counter */}
            <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 bg-black/60 backdrop-blur-sm rounded-full px-4 py-2 text-white text-sm">
              {selectedImageIndex + 1} / {filteredItems.length}
            </div>

            {/* Thumbnail Strip */}
            <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 max-w-lg overflow-x-auto pb-2">
              {filteredItems.map((item, index) => (
                <button
                  key={item.id}
                  onClick={() => setSelectedImageIndex(index)}
                  className={`flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden transition-all duration-300 ${
                    index === selectedImageIndex
                      ? "ring-2 ring-white scale-110"
                      : "opacity-60 hover:opacity-100"
                  }`}
                >
                  {item.image?.endsWith(".mp4") ? (
                    <div className="relative w-full h-full">
                      <video
                        src={item.image}
                        className="w-full h-full object-cover"
                        muted
                        loop
                        playsInline
                        autoPlay
                      />
                      <div className="absolute top-1 right-1 rounded-full bg-black/70 p-1 text-white">
                        <Video className="w-3 h-3" />
                      </div>
                    </div>
                  ) : (
                    <img
                      src={item.image}
                      alt={`Thumbnail ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  )}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(40px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }

        .animate-scaleIn {
          animation: scaleIn 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default GalleryPage;
